import React, { Component } from 'react';

import {
  Link
} from "react-router-dom";

class Banner extends Component {
	render() {
		return (
			<div className="homebanner">
				<div className="container-fluid">
					<div className="homebanner__text">
						<h1 className="homebanner__text--heading">Skincare, <em>reimagined for</em> you.</h1>
						<p className="homebanner__text--paragraph">Taking guesswork, toxins, and cruelty out of skincare.</p>
						<Link className="btn btn-primary" to="/product" title="">Personalise Now</Link>
					</div>
				</div>
			</div>
		);
	}
}


export default Banner;